import React, {useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSignOut} from '@fortawesome/free-solid-svg-icons';
import { ADMIN_API_BASE } from "../../utils/apiConfig";
import Button from "../../components/elements/Button";

const AdminHeader = ({title}) => {
        const [loading, setLoading] = useState('');
        const [error, setError] = useState('');

        const handleClick = async () => {
            setLoading(true);
            setError("");

            try {
                const token = await getCsrfToken();

                const response = await fetch(`${ADMIN_API_BASE}/logout/`, {
                    method: "POST",
                    headers: {
                        'csrf-token': token,
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${process.env.REACT_APP_ADMIN_TOKEN}`,
                    },
                    withCredentials: true,
                });

                const data = await response.json();

                if (response.ok && data.success) {
                    // ✅ OTP verified — redirect
                    window.location.href = "/";
                } else {
                    setError(data.message);
                }
            } catch (err) {
                setError("Logout failed.");
            } finally {
                setLoading(false);
            }
        };

    const getCsrfToken = async () => {
        const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include", // critical to send the session cookie
        });

        const data = await response.json();
        return data.csrfToken;
    };

        return (
            <div className='bg-black py-3 px-5 relative m-5 rounded-md shadow-md flex flex-1 items-center'>
                <div className='flex-grow'>
                    <div className='text-xl text-white text-bold'>
                        <h1>{title}</h1>
                    </div>
                </div>
                <Button
                    onClick={handleClick}
                    className='w-fit flex gap-2 text-sm bg-white items-center cursor-pointer hover:bg-gray-100 transition-colors rounded-md p-3'>
                    <span>خروج</span>
                    <FontAwesomeIcon icon={faSignOut} className='rotate-180'/>
                </Button>
            </div>
        );
    }
;

export default AdminHeader;
